import { identity, result } from 'underscore';
import { getBulkApiErrors } from '@bingads-webui-campaign/api-errors';

export const mapBulkUpsertErrors = (errors, bulkUpsertEntityErrorMap, errorProcessor = identity, scenario, i18n, activityLogger) =>
  getBulkApiErrors(errors, scenario, i18n, activityLogger).map((error) => {
    const errorType = error.type;
    const mappedErrorType = result(bulkUpsertEntityErrorMap, errorType, errorType);
    // eslint-disable-next-line no-param-reassign
    error.type = mappedErrorType;
    return errorProcessor(error);
  });
